import { render } from "./GiantsSlider.vue?vue&type=template&id=64febfa0&lang=pug"
import script from "./GiantsSlider.vue?vue&type=script&lang=ts"
export * from "./GiantsSlider.vue?vue&type=script&lang=ts"

import "./GiantsSlider.vue?vue&type=style&index=0&id=64febfa0&lang=scss"
script.render = render

export default script